/* ⚠️ GENERATED from app/services/friendRequests.ts by gen-twins.mjs — edit the TypeScript, not this. */
// services/friendRequests.ts — may I send this person a friend request?
//
// 🟥 TODAY THE ANSWER IS ALWAYS YES, AND NOTHING ASKS. Both clients write to
//    the `friendRequests` collection directly, the deployed rule for it is
//    `allow read, write: if signedIn()`, and the sender's own document is never
//    read. So anybody signed in can create a request addressed to anybody, and
//    could always forge one FROM anybody too.
//
// 🟥 WHICH IS WHY A BUTTON IS NOT THE FIX. Hiding "Add friend" stops the two
//    apps and nothing else. The same argument the ban check makes a few files
//    away: "The posting ban was enforced by disabling a button. That is not
//    enforcement, it is a suggestion." So this rule is written three times on
//    purpose — here for the phone, in the generated twin for the browser, and
//    in `MERGED_RULES.rules` for everything else — and the suite checks the
//    third one still says what the first two say.
//
// 🟢 ABSENT MEANS OPEN. Every account that existed before this setting has no
//    value for it, and reading that as "locked" would silently cut off every
//    one of them. Same convention as every other setting in `privacySettings`.

/** The setting as the two words the UI offers. */
export function friendRequestSetting(doc) {
  return doc?.privacySettings?.friendRequests === 'nobody' ? 'nobody' : 'everyone';
}

/** What the chosen word writes back. */
export const friendRequestValue = locked => locked ? 'nobody' : 'everyone';

/** True when this account has turned requests off. */
export const acceptsFriendRequests = doc => friendRequestSetting(doc) === 'everyone';
/**
 * Why this request cannot be sent, or null if it can.
 *
 * 🟥 THE ORDER OF THE CHECKS IS PART OF THE ANSWER. "Blocked" is reported
 *    before "locked" because a blocked sender must not learn anything at all
 *    about the other account's settings, and a lock is a setting. Sending
 *    yourself a request is checked first because it is a bug rather than a
 *    refusal, and it should not be reported to anyone as one.
 */
export function whyCannotSend(target, senderUid, targetUid) {
  const me = String(senderUid || '');
  const them = String(targetUid || '');
  if (!me || !them || me === them) return 'self';
  if (Array.isArray(target?.blockedUsers) && target.blockedUsers.includes(me)) return 'blocked';
  if (!acceptsFriendRequests(target)) return 'locked';
  return null;
}

/** The plain question, for a caller that does not care why. */
export const canSendFriendRequest = (target, senderUid, targetUid) => whyCannotSend(target, senderUid, targetUid) === null;
